import useEmblaCarousel from "embla-carousel-react"
import styled from "styled-components"
import {NextButton, PrevButton, usePrevNextButtons,} from "../../Button/EmblaButtons"
import {ReviewCard} from "./ReviewCard"

const OPTIONS = {axis: "x", dragFree: true, loop: true, slidesToScroll: 1};

export const ReviewCardSlider = ({reviews}) => {
    const [emblaRef, emblaApi] = useEmblaCarousel(OPTIONS)

    const {
        prevBtnDisabled,
        nextBtnDisabled,
        onPrevButtonClick,
        onNextButtonClick,
    } = usePrevNextButtons(emblaApi)

    if (!reviews.length) {
        return null;
    }

    return (
        <Embla>
            <EmblaControls>
                <EmblaTitle>Reviews</EmblaTitle>
                <EmblaButtons>
                    <PrevNav onClick={onPrevButtonClick} disabled={prevBtnDisabled}/>
                    <NextNav onClick={onNextButtonClick} disabled={nextBtnDisabled}/>
                </EmblaButtons>
            </EmblaControls>

            <EmblaViewport ref={emblaRef}>
                <EmblaContainer>
                    {reviews?.map((item, index) => (
                        <EmblaSlide key={index}>
                            <ReviewCard
                                reviewData={item}
                            />
                        </EmblaSlide>
                    ))}
                </EmblaContainer>
            </EmblaViewport>
        </Embla>
    )
}


const Embla = styled.section`
    max-width: 100%;
    height: 100%;
    margin: auto;
`


const EmblaViewport = styled.div`
    overflow: hidden;

`

const EmblaContainer = styled.div`
    display: flex;
    touch-action: pan-y pinch-zoom;
    margin-left: calc(1rem * -1);
`

const EmblaSlide = styled.div`
    flex: 0 0 100%;
    min-width: 0;
    min-height: 285px;
    padding-left: 1rem;
`

const EmblaControls = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1.2rem;
    margin-bottom: 20px;
    margin-top: 13px;
`
const EmblaButtons = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 0.6rem;
    align-items: center;
`
const PrevNav = styled(PrevButton)`
    width: 52px;
    height: 52px;

    @media (max-width: 1024px) {
        width: 36px;
        height: 36px;
    }
`
const NextNav = styled(NextButton)`
    width: 52px;
    height: 52px;

    @media (max-width: 1024px) {
        width: 36px;
        height: 36px;
    }
`
const EmblaTitle = styled.div`
    font-family: var(--font-secondary);
    font-size: 28px;
    font-weight: 600;
    line-height: 130%;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;

    @media (max-width: 1024px) {
        font-size: 22px;
    }
`